import { StakeLogo } from "../../Assets/Images";

export default function Shell({ email, children, onSignOutClick }) {
  return (
    <div className="stake-utilities">
      <header className="su-header">
        <StakeLogo className="su-logo" aria-label="Stake" />
        <button className="su-signout" type="button" onClick={onSignOutClick}>
          Sign Out{email ? <span>({email})</span> : null}
        </button>
      </header>
      <main className="su-main">{children}</main>
    </div>
  );
}
